import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue'; //引入高德地图组件

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  // key: '7daada729f1d0f721161104b0e2a47ff',
  key: 'f8b6aa60375b13991b5c584b69c89f60',
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geolocation'],
  v: '1.4.4'
});
window._AMapSecurityConfig = {
  securityJsCode: '331925378592d07199ededae5f1d7520'
};
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_map_amap',
  props: {
    //地图图形主键数组
    // value: {
    //   type: Array,
    //   default: function(){return[]}
    // },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pageSetInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dataInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    //可绘制的图形个数
    maxNum: {
      type: Number,
      default: 1
    },
    //编辑状态  1:编辑  2:查看
    editType: {
      type: Number,
      default: 1
    },
    nowCenter: {
      type: Object,
      default: function _default() {
        return {
          lng: 116.404,
          lat: 39.915
        };
      }
    },
    //圆半径 
    circleRadius: {
      type: Number,
      default: 150
    },
    ifRefresh: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var self = this;
    return {
      ifLoad: false,
      //地图图形对应的数据数组
      valueInfo: [],
      //图形类型数组
      drawingTypeInfo: [{
        name: "点",
        value: 1
      }, {
        name: "海量点",
        value: 2
      }, {
        name: "折线",
        value: 3
      }, {
        name: "多边形",
        value: 4
      }, {
        name: "圆形",
        value: 5
      }, {
        name: "标签",
        value: 6
      }],
      //当前要新增的图形类型
      nowDrawingType: 1,
      clickLocation: {
        lng: 0,
        lat: 0
      },

      /**
       * 弹出层组件的信息
       */
      dialogInfo: {
        ifLoad: false
      },
      keyword: "",
      mapCenter: [114.417283, 36.112539],
      mapEvents: {
        'dblclick': function dblclick(e) {
          self.addDrawing(e);
        }
      },
      plugin: [{
        pName: 'Geolocation',
        events: {
          init: function init(o) {// o 是高德地图定位插件实例
            // o.getCurrentPosition((status, result) => {
            //   if (result && result.position && self.mapCenter[0] == 114.417283) {
            //     self.mapCenter = [result.position.lng, result.position.lat];
            //   }
            // });
          }
        }
      }],
      searchOption: {
        citylimit: false
      },
      markers: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.value.styleSet) {
      if (this.value.styleSet.drawingType) {
        this.nowDrawingType = this.value.styleSet.drawingType;
      }

      if (this.value.styleSet.initKeyWord) {
        this.keyword = this.value.styleSet.initKeyWord;
      }

      if (this.dataInfo && this.dataInfo["INIT_KEYWORD"]) {
        this.keyword = this.dataInfo["INIT_KEYWORD"];
      }
    }

    if (this.value.styleSet.ifDrawingData != 2) {
      this.loadJsonInfoFromDb();
    } else {
      this.loadShowData();
    } //根据图形主键数组 加载地图图形数据

  },
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},
  watch: {
    ifRefresh: function ifRefresh(newVal) {
      console.log("pageSetInfo==============watch================", this.pageSetInfo);
      this.loadShowData();
    }
  },
  computed: {},
  components: {},
  methods: {
    openMapDialog: function openMapDialog() {
      this.dialogInfo.ifLoad = true;
    },
    closeMapDialog: function closeMapDialog() {
      this.dialogInfo.ifLoad = false;
    },

    /**从后台数据库中加载数据 */
    loadJsonInfoFromDb: function loadJsonInfoFromDb() {
      var that = this;

      if (that.value.defaultCheckValue) {
        var toHtData = {};
        toHtData.tableInfo = '{"MAP_DRAWING":[{"MAP_DRAWING_POINT":[]}]}';
        toHtData.mainId = that.value.defaultCheckValue;
        var loading = that.$loading({
          lock: true,
          text: '加载数据中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var url = "wxXcxSet_getJsonInfoFromDb.do"; //根据pageId获取列表页面的设置信息 获取列表页面的数据信息

        utils.request(that, {
          url: url,
          //仅为示例，并非真实的接口地址
          data: toHtData,
          success: function success(res) {
            loading.close();
            console.log("res.data=======================", res.data);
            var loadHtJson = res.data;
            var MAP_DRAWING = loadHtJson.MAP_DRAWING;
            var valueInfo = [];
            var mapCenter = [];
            MAP_DRAWING.forEach(function (valueOne) {
              var path = [];
              var arrayPath = [];

              if (valueOne.MAP_DRAWING_POINT) {
                valueOne.MAP_DRAWING_POINT.forEach(function (one) {
                  path.push({
                    "lng": one.LONGITUDE,
                    "lat": one.LATITUDE
                  });
                  arrayPath.push([one.LONGITUDE, one.LATITUDE]);
                });
              }

              valueInfo.push({
                "MD_NAME": valueOne.MD_NAME,
                "ZD_DRAWING_TYPE": valueOne.ZD_DRAWING_TYPE,
                "MD_RADIUS": valueOne.MD_RADIUS,
                "MAP_CENTER_LNG": valueOne.MAP_CENTER_LNG,
                "MAP_CENTER_LAT": valueOne.MAP_CENTER_LAT,
                "path": path,
                "arrayPath": arrayPath,
                "events": that.loadMarketEvent(valueOne.ZD_DRAWING_TYPE)
              });

              if (valueOne.MAP_CENTER_LNG > 0) {
                mapCenter[0] = valueOne.MAP_CENTER_LNG;
                mapCenter[1] = valueOne.MAP_CENTER_LAT;
              }
            });
            that.mapCenter = mapCenter;
            that.valueInfo = valueInfo;
            that.ifLoad = true;
          },
          error: function error() {
            loading.close(); // 保存失败

            that.$message({
              message: "服务器出现问题,请重试或者联系管理员",
              type: 'error'
            });
          }
        });
      } else {
        that.ifLoad = true;
      }
    },
    loadMarketEvent: function loadMarketEvent(ZD_DRAWING_TYPE) {
      var that = this;
      var events = {
        click: function click(event) {
          var valueInfoIndex = event.target.w.vid;
          console.log('click------------', event);
          var valueInfoOne = that.valueInfo[valueInfoIndex];
          that.delDraw(event, valueInfoOne, valueInfoIndex);
        }
      };

      if (ZD_DRAWING_TYPE == 1) {} else if (ZD_DRAWING_TYPE == 3 || ZD_DRAWING_TYPE == 4) {
        //折线
        events.addnode = function (event) {
          console.log('move------------', event);
          var valueInfoIndex = event.target.w.vid;
          var valueInfoOne = that.valueInfo[valueInfoIndex]; // valueInfoOne.path = [{"lng":event.lnglat.lng,"lat":event.lnglat.lat}];

          console.log("arrayPath===============", valueInfoOne.arrayPath, event.target.De.path);
          valueInfoOne.arrayPath = event.target.De.path;
          var path = [];
          valueInfoOne.arrayPath.forEach(function (pathOne) {
            path.push({
              lng: pathOne[0],
              lat: pathOne[1]
            });
          });
          valueInfoOne.path = path;
        };

        events.removenode = function (event) {
          console.log('move------------', event);
          var valueInfoIndex = event.target.w.vid;
          var valueInfoOne = that.valueInfo[valueInfoIndex]; // valueInfoOne.path = [{"lng":event.lnglat.lng,"lat":event.lnglat.lat}];

          console.log("arrayPath===============", valueInfoOne.arrayPath, event.target.De.path);
          valueInfoOne.arrayPath = event.target.De.path;
          var path = [];
          valueInfoOne.arrayPath.forEach(function (pathOne) {
            path.push({
              lng: pathOne[0],
              lat: pathOne[1]
            });
          });
          valueInfoOne.path = path;
        };

        events.adjust = function (event) {
          console.log('adjust------------', event);
          var valueInfoIndex = event.target.w.vid;
          var valueInfoOne = that.valueInfo[valueInfoIndex]; // valueInfoOne.MD_RADIUS = event.radius;

          console.log("arrayPath===============", valueInfoOne.arrayPath, event.target.De.path);
          valueInfoOne.arrayPath = event.target.De.path;
          var path = [];
          valueInfoOne.arrayPath.forEach(function (pathOne) {
            path.push({
              lng: pathOne[0],
              lat: pathOne[1]
            });
          });
          valueInfoOne.path = path;
        };
      } else if (ZD_DRAWING_TYPE == 5) {
        //圆形
        events.move = function (event) {
          console.log('move------------', event);
          var valueInfoIndex = event.target.w.vid;
          var valueInfoOne = that.valueInfo[valueInfoIndex];
          valueInfoOne.path = [{
            "lng": event.lnglat.lng,
            "lat": event.lnglat.lat
          }];
        };

        events.adjust = function (event) {
          console.log('adjust------------', event);
          var valueInfoIndex = event.target.w.vid;
          var valueInfoOne = that.valueInfo[valueInfoIndex];
          valueInfoOne.MD_RADIUS = event.radius;
        };
      }

      return events;
    },

    /**保存数据到后台 */
    saveJsonInfoToDb: function saveJsonInfoToDb() {
      var that = this;
      pageUtils.saveMapDrawingInfo(that);
    },
    //选中当前要增加的图形
    chooseDrawingType: function chooseDrawingType(drawingType) {
      this.nowDrawingType = drawingType;
    },
    //添加一个绘制图形
    addDrawing: function addDrawing(e) {
      var that = this;
      console.log("--e--", e);
      this.clickLocation.lng = e.lnglat.lng;
      this.clickLocation.lat = e.lnglat.lat;
      var ifCanAdd = true;
      var valueInfo = this.valueInfo;
      console.log("valueInfo==================", valueInfo);

      if (this.maxNum > 0 && valueInfo.length >= this.maxNum) {
        ifCanAdd = false;
      }

      if (ifCanAdd) {
        var drawingType = this.nowDrawingType;
        var name = this.drawingTypeInfo[drawingType - 1].name + this.valueInfo.length;
        var valueOne = {
          MD_NAME: name,
          ZD_DRAWING_TYPE: drawingType,
          MD_RADIUS: this.circleRadius,
          path: [],
          arrayPath: []
        }; //当前中心位置 nowCenter

        var nowCenter = this.clickLocation; //海量点

        if (drawingType == 1) {
          valueOne.path.push({
            lng: nowCenter.lng + 0,
            lat: nowCenter.lat + 0
          });
        } //海量点


        if (drawingType == 2) {
          valueOne.path.push({
            lng: nowCenter.lng + 0,
            lat: nowCenter.lat + 0
          });
        }

        if (drawingType == 3) {
          valueOne.path.push({
            lng: nowCenter.lng,
            lat: nowCenter.lat
          });
          valueOne.path.push({
            lng: nowCenter.lng + 0.001,
            lat: nowCenter.lat + 0.01
          });
          valueOne.path.push({
            lng: nowCenter.lng + 0.023,
            lat: nowCenter.lat - 0.008
          });
          valueOne.arrayPath.push([nowCenter.lng + 0, nowCenter.lat + 0]);
          valueOne.arrayPath.push([nowCenter.lng + 0.001, nowCenter.lat + 0.01]);
          valueOne.arrayPath.push([nowCenter.lng + 0.023, nowCenter.lat + 0.008]);
        } //多边形


        if (drawingType == 4) {
          valueOne.path.push({
            lng: nowCenter.lng - 0.008,
            lat: nowCenter.lat - 0.008
          });
          valueOne.path.push({
            lng: nowCenter.lng + 0.008,
            lat: nowCenter.lat - 0.008
          });
          valueOne.path.push({
            lng: nowCenter.lng + 0.008,
            lat: nowCenter.lat + 0.008
          });
          valueOne.path.push({
            lng: nowCenter.lng - 0.008,
            lat: nowCenter.lat + 0.008
          });
          valueOne.arrayPath.push([nowCenter.lng - 0.008, nowCenter.lat - 0.008]);
          valueOne.arrayPath.push([nowCenter.lng + 0.008, nowCenter.lat - 0.008]);
          valueOne.arrayPath.push([nowCenter.lng + 0.008, nowCenter.lat + 0.008]);
          valueOne.arrayPath.push([nowCenter.lng - 0.008, nowCenter.lat + 0.008]);
        } //圆


        if (drawingType == 5) {
          valueOne.path.push({
            lng: nowCenter.lng + 0,
            lat: nowCenter.lat + 0
          });
        } //标签


        if (drawingType == 6) {
          valueOne.path.push({
            lng: nowCenter.lng + 0,
            lat: nowCenter.lat + 0
          });
        }

        valueOne.events = that.loadMarketEvent(valueOne.ZD_DRAWING_TYPE);
        valueInfo.push(valueOne);
      } else {
        this.$message.error('图形个数已经大于' + this.maxNum + ',不可新增图形');
      }

      console.log("valueInfo============add ======", valueInfo);
    },
    //多边形、拆线使用
    updatePolygonPath: function updatePolygonPath(e, valueInfoOne) {
      valueInfoOne.path = e.target.getPath();
    },
    //删除多边形
    delDraw: function delDraw(e, valueInfoOne, valueInfoIndex) {
      this.valueInfo.splice(valueInfoIndex, 1); // e.target.remove();

      console.log("-valueInfo---", this.valueInfo);
    },
    //折线添加坐标点
    addPolylinePoint: function addPolylinePoint(valueInfoOne) {
      valueInfoOne.path.push({
        lng: nowCenter.lng,
        lat: nowCenter.lat
      });
    },
    // //海量点击事件
    // clickHandler (e) {
    //   alert(`单击点的坐标为：${e.point.lng}, ${e.point.lat}`);
    // },
    onSearchResult: function onSearchResult(pois) {
      var _this = this;

      var latSum = 0;
      var lngSum = 0;

      if (pois.length > 0) {
        pois.forEach(function (poi) {
          var lng = poi.lng,
              lat = poi.lat;
          lngSum += lng;
          latSum += lat;

          _this.markers.push([poi.lng, poi.lat]);
        });
        var center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length
        };
        this.mapCenter = [center.lng, center.lat];
      }
    },
    //从dataInfo和关联数据中读取展示内容
    loadShowData: function loadShowData() {
      var that = this;
      var valueInfo = [];
      var valueOne = this.dataInfo; //从dataInfo中获取当前位置

      valueInfo.push({
        "MD_NAME": valueOne.MD_NAME,
        "ZD_DRAWING_TYPE": 1,
        "MAP_CENTER_LNG": valueOne.MAP_CENTER_LNG,
        "MAP_CENTER_LAT": valueOne.MAP_CENTER_LAT,
        "path": [{
          "lng": valueOne.MAP_CENTER_LNG,
          "lat": valueOne.MAP_CENTER_LAT
        }]
      });
      var mapCenter = [];
      mapCenter[0] = valueOne.MAP_CENTER_LNG;
      mapCenter[1] = valueOne.MAP_CENTER_LAT;
      that.mapCenter = mapCenter; //获取弹出层子页面的数据进行地图的绘制

      var pageSetInfo = this.pageSetInfo;
      var tabPageSet = pageSetInfo.tabPageSet;

      if (tabPageSet) {
        //第一个选项卡为实体 第二个选项卡为关系 第三个选项卡为属性
        if (tabPageSet.length >= 1) {
          var tabOne = tabPageSet[0];

          if (tabOne.pageDataInfo) {
            var arrayPath = [];
            tabOne.pageDataInfo.forEach(function (markerOne, markerIndex) {
              arrayPath.push([markerOne.LNG, markerOne.LAT]);
            });
            var mapLine = {
              "MD_NAME": valueOne.MD_NAME,
              "ZD_DRAWING_TYPE": 3,
              "path": [],
              "arrayPath": arrayPath
            };
            valueInfo.push(mapLine);
          }
        }

        if (tabPageSet.length >= 2) {
          var tabOne = tabPageSet[1];

          if (tabOne.pageDataInfo) {
            var arrayPath = [];
            tabOne.pageDataInfo.forEach(function (markerOne, markerIndex) {
              var mapCircle = {
                "MD_NAME": markerOne.MD_NAME,
                "ZD_DRAWING_TYPE": 5,
                "MD_RADIUS": markerOne.MD_RADIUS,
                "path": [{
                  "lng": markerOne.LNG,
                  "lat": markerOne.LAT
                }]
              };
              valueInfo.push(mapCircle);
            });
          }
        }
      }

      that.valueInfo = valueInfo;
      console.log("mapCenter====================", mapCenter);
      console.log("valueInfo====================", valueInfo);
      that.ifLoad = true;
    }
  }
};